<div class="host">
    <div class="d-flex flex-column align-items-center">
        <div><img src="assets/img/Illustration_entreprise_resultat.png" alt="company logo" class="page-image" /></div>
        <div class="raison-sociale lg-text">{{ raisonSociale }}</div>
        <div class="siret md-text">SIRET {{ siret }}</div>
    </div>
</div>
